"use client";

import { useEffect } from "react";
import { incrementTalkPostView } from "@/lib/server-actions/community-talk/posts";

/** 조회수 +1. 같은 브라우저 탭 세션에서는 글당 한 번만 센다(새로고침 도배 방지). 화면에는 아무것도 그리지 않는다. */
export default function TalkViewCounter({ postId }: { postId: number }) {
  useEffect(() => {
    const key = `talk-viewed-${postId}`;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, "1");
    } catch {
      // 저장소 접근 불가(프라이빗 모드 등)면 그냥 한 번 센다.
    }
    void incrementTalkPostView(postId);
  }, [postId]);
  return null;
}
